import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
} from '@mui/material';
import SaveButton from '../Buttons/saveButton';
import CancelButton from '../Buttons/cancelButton';

interface DeleteModalProps {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}
export const mediumButtonStyles = {
  fontSize: '1rem',
  padding: '0.3rem 0.9rem',
  borderRadius: '0.5rem',
};
function DeleteModal({
  open,
  title,
  message,
  onConfirm,
  onCancel,
}: DeleteModalProps) {
  const handleConfirm = () => {
    onConfirm();
  };
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: '0.3rem',
          boxShadow: '0rem 0.5rem 1rem rgba(0,0,0,0.12)',
          maxWidth: '30rem',
          width: '100%',
        },
      }}
    >
      <Box padding="0.1rem">
        <DialogTitle
          id="confirm-dialog-title"
          sx={{
            fontSize: '1.1rem',
            fontWeight: 'bold',
            color: '#2e3b4e',
          }}
        >
          {title}
        </DialogTitle>
        <DialogContent sx={{}}>
          <DialogContentText
            id="confirm-dialog-description"
            sx={{ fontSize: '1rem', color: '#21284c' }}
          >
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'end',
            paddingBottom: '0.5rem',
            gap: '0.5rem',
          }}
        >
          <CancelButton
            buttonText="Cancel"
            onClick={() => onCancel()}
            sx={mediumButtonStyles}
          />
          <SaveButton
            buttonText="Confirm"
            onClick={() => handleConfirm()}
            sx={mediumButtonStyles}
          />
        </DialogActions>
      </Box>
    </Dialog>
  );
}
export default DeleteModal;
